<template>
  <messages-list :chat-list="serviceChatList"
                  class="root-service-messages"/>
</template>

<script>
  import MessagesList from '@/views/messages/messages-list';

  export default {
    name: 'root-service-messages',
    components: {
      MessagesList,
    },
    props: {
      chatList: {type: Array, default: () => []},
    },
    data() {
      return {
        serviceChatList: this.chatList
          .filter((chatItem) => !!chatItem.order),
      };
    },
  }
</script>
